// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1a0F3","top":"styles_top__1S2gK"};